import { render, staticRenderFns } from "./LegalDoc.vue?vue&type=template&id=64d6bc22&scoped=true"
import script from "./LegalDoc.vue?vue&type=script&lang=js"
export * from "./LegalDoc.vue?vue&type=script&lang=js"
import style0 from "./LegalDoc.vue?vue&type=style&index=0&id=64d6bc22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d6bc22",
  null
  
)

export default component.exports